import { render, staticRenderFns } from "./CaseManage.vue?vue&type=template&id=5e6cd928&scoped=true"
import script from "./CaseManage.vue?vue&type=script&lang=js"
export * from "./CaseManage.vue?vue&type=script&lang=js"
import style0 from "./CaseManage.vue?vue&type=style&index=0&id=5e6cd928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6cd928",
  null
  
)

export default component.exports